import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon} from './Icon';
import {createActiveMenuArray} from '../../helpers/Helpers';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';

import Config from '../../config/index';
import _ from 'lodash';

class SubBarSubItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    componentDidMount() {
        const {id, section, content, block, menu, params} = this.props;

        if (section === 'page') {
            const active = createActiveMenuArray(content.menu, parseInt(params.page, 10));

            this.setState({
                expanded: _.includes(active, id)
            });
        }

        if (section === 'block') {
            const active = createActiveMenuArray(block.menu, parseInt(params.block, 10));
            
            this.setState({
                expanded: _.includes(active, id)
            });
        }

        if (section === "menu") {
            const active = createActiveMenuArray(menu.menu, parseInt(params.menu, 10));
  
            this.setState({
                expanded: _.includes(active, id)
            });
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const {id, section, content, block, menu, params} = this.props;

        if (this.props.workspace.single.id !== newProps.workspace.single.id) {
            this.setState({
                expanded: false
            });
        } else {
            if (section === 'page') {
                const active = createActiveMenuArray(content.menu, parseInt(params.page, 10));

                this.setState({
                    expanded: _.includes(active, id)
                });
            }

            if (section === 'block') {
                const active = createActiveMenuArray(block.menu, parseInt(params.block, 10));

                this.setState({
                    expanded: _.includes(active, id)
                });
            }

            if (section === 'menu') {
                const active = createActiveMenuArray(menu.menu, parseInt(params.menu, 10));

                this.setState({
                    expanded: _.includes(active, id)
                });
            }
        }
    }

    toggleExpand(e) {
        e.preventDefault();

        this.setState(prevState => ({
            expanded: !prevState.expanded
        }));
    }

    isExpanded(item) {
        if (item.expanded && item.expanded === true) {
            return true;
        } else {
            return this.state.expanded;
        }
    }

    render() {
        const {
            title,
            item,
            children,
            expandable,
            active
        } = this.props;
        
        return (
            <ul>
                <li
                    className={classNamesPrefixed({
                        'sub-bar-sub-item': true,
                        'active': this.isExpanded(item)
                    })}
                >
                    <div className={classNamesPrefixed({ 'sub-bar-sub-item__container': true, 'sub-bar-sub-item__container--active': active })}>
                        {title}
                        {
                            expandable && (
                                <span className="toggle-expand-icon" onClick={this.toggleExpand.bind(this)}>
                                    <Icon name={this.isExpanded(item) ? 'caret-up' : 'caret-down'} type='fas' />
                                </span>
                            )
                        }
                    </div>
                    {React.Children.map(children, (child) => {
                        if (child.type === 'ul') {
                            return React.cloneElement(child, {
                                className: this.isExpanded(item) ? Config.prefix + 'active' : ''
                            })
                        } else {
                            return child;
                        }
                    })}
                </li>
            </ul>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        block: state.block,
        routing: state.routing,
        workspace: state.workspace
    };
};

export default connect(mapStateToProps)(SubBarSubItem);


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/SubBarSubItem.js